<template>
    <div class="requerimento" v-if="!loading">

            <!-- cabelalho -->
            <div>
                <table>
                    <tr>
                        <td valign="top" class="col-t-45 center top">
                            <h2>PREFEITURA DE MORRO DO CHAPÉU</h2>
                            <h3>SECRETARIA MUNICIPAL DA EDUCAÇÃO</h3>
                        </td>
                        <td valign="top" class="col-t-45 center top">
                            <h1>HISTÓRICO ESCOLAR</h1>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- dados da instituição -->
            <div class="borda mt-10">
                <table class="linha-tabela">
                    <tr>
                        <th class="col-t-80 coluna-tabela">
                            <p><b>Unidade Escolar: </b> {{ dados.instituicao.nome }}</p>
                        </th>
                        <th class="col-t-20 coluna-tabela ultima-coluna">
                            <p><b>Código: </b>{{ dados.instituicao.cod }}</p>
                        </th>
                    </tr>
                </table>
                <table class="linha-tabela">
                    <tr>
                        <th class="col-t-100 coluna-tabela ultima-coluna">
                            <p><b>Endereço: </b> {{ dados.instituicao.endereco }}</p>
                        </th>
                    </tr>
                </table>
                <table class="linha-tabela ultima-linha">
                    <tr>
                        <th class="col-t-50 coluna-tabela">
                            <p><b>Cod. Autorização: </b> {{ dados.instituicao.autorizacao }}</p>
                        </th>
                        <th class="col-t-50 coluna-tabela ultima-coluna">
                            <p><b>Cód. de Segurança de Res. CME no 030/00: </b> {{ dados.instituicao.cod_seguranca }}</p>
                        </th>
                    </tr>
                </table>
            </div>

            <!-- dados do aluno -->
            <div class="borda mt-10">
                <table class="linha-tabela">
                    <tr>
                        <th class="col-t-80 coluna-tabela">
                            <p><b>Nome do Aluno: </b> {{ dados.aluno.nome }}</p>
                        </th>
                        <th class="col-t-20 coluna-tabela ultima-coluna">
                            <p><b>Sexo: </b>{{ dados.aluno.sexo }}</p>
                        </th>
                    </tr>
                </table>
                <table class="linha-tabela">
                    <tr>
                        <th class="col-t-25 coluna-tabela">
                            <p><b>Data de Nascimento: </b> {{ dados.aluno.data_nascimento }}</p>
                        </th>
                        <th class="col-t-25 coluna-tabela">
                            <p><b>Naturalidade: </b> {{ dados.aluno.naturalidade }}</p>
                        </th>
                        <th class="col-t-25 coluna-tabela ultima-coluna">
                            <p><b>Nacionalidade: </b> {{ dados.aluno.nacionalidade }}</p>
                        </th>
                    </tr>
                </table>
                <table class="linha-tabela ultima-linha">
                    <tr>
                        <th class="col-t-50 coluna-tabela">
                            <p><b>Nome do Pai: </b> {{ dados.aluno.pai }}</p>
                        </th>
                        <th class="col-t-50 coluna-tabela ultima-coluna">
                            <p><b>Nome da Mãe: </b> {{ dados.aluno.mae }}</p>
                        </th>
                    </tr>
                </table>
            </div>

            <!-- notas -->
            <div class="borda mt-10">
                <table class="tabela-nota linha-tabela ultima-linha">
                    <tr>
                        <th colspan="10" class="col-t-30 coluna-tabela center ultima-coluna">
                            <p>NOTAS</p>
                        </th>
                    </tr>
                    <tr>
                        <th class="col-t-15 coluna-tabela border-top">
                            <p>Áreas de Conhecimentos</p>
                        </th>
                        <th @click="showDialogEditNotas(idNota)" v-for="(nota, idNota) in dados.grade.conteudo.notas" class="col-t-5 coluna-tabela center border-top u-pointer">
                            <p>
                                {{ $CONSTANTS.CURSO_NACIONAL[idNota] }} 
                                <i class="fas fa-edit" style="color: #838383"></i> <br>
                                Média
                            </p>                            
                        </th>
                    </tr>
                    <tr v-for="(disciplina, idDisciplina) in dados.disciplinas">
                        <th class="col-t-15 coluna-tabela border-top">
                            <p>{{ disciplina }}</p>
                        </th>
                        <template v-for="(nota, idNota) in dados.grade.conteudo.notas">
                            <template v-if="nota.tipo == 'qualitativo'">
                                <th class="col-t-5 coluna-tabela center border-top">
                                    <p>resolução</p>
                                </th>                                     
                            </template>
                            <template v-else>
                                <th class="col-t-5 coluna-tabela center border-top">
                                    <p>{{ nota.disciplinas[idDisciplina] }}</p>
                                </th>
                            </template>
                        </template>                        
                    </tr>      
                    <tr>
                        <th class="col-t-15 coluna-tabela border-top">
                            <p>Faltas</p>
                        </th>
                        <template v-for="(nota, idNota) in dados.grade.conteudo.notas">
                            <th class="col-t-5 coluna-tabela center border-top">
                                <p>{{ nota.total_faltas }}</p>
                            </th>
                        </template>                        
                    </tr>        
                    <tr>
                        <th class="col-t-15 coluna-tabela border-top">
                            <p>Carga horária anual</p>
                        </th>
                        <template v-for="(nota, idNota) in dados.grade.conteudo.notas">
                            <th class="col-t-5 coluna-tabela center border-top">
                                <p>{{ nota.carga_horaria_anual }}</p>
                            </th>
                        </template>                        
                    </tr>  
                </table>
            </div>

            <!-- estudos realizados -->
            <div class="borda mt-10">
                <table class="tabela-nota linha-tabela ultima-linha">
                    <tr>
                        <th colspan="5" class="col-t-30 coluna-tabela center ultima-coluna">
                            <p>ESTUDOS REALIZADOS</p>
                        </th>
                    </tr>
                    <tr>
                        <th class="col-t-30 coluna-tabela border-top">
                            <p>Modalidade de Ensino</p>
                        </th>
                        <th class="col-t-10 coluna-tabela center border-top">
                            <p>Ano</p>
                        </th>
                        <th class="col-t-30 coluna-tabela center border-top">
                            <p>Unidade de Ensino</p>
                        </th>
                        <th class="col-t-20 coluna-tabela center border-top">
                            <p>Cidade</p>
                        </th>
                        <th class="col-t-10 coluna-tabela center border-top ultima-coluna">
                            <p>UF</p>
                        </th>
                    </tr>
                    <tr v-for="(nota, idNota) in dados.grade.conteudo.notas">
                        <th @click="showDialogEstudosRealizados(idNota)" class="col-t-30 coluna-tabela border-top u-pointer">
                            <p>
                                {{ idNota ? $CONSTANTS.CURSO_NACIONAL[idNota] : '-' }}
                                <i class="fas fa-edit" style="color: #838383"></i>
                            </p>
                        </th>
                        <th class="col-t-10 coluna-tabela center border-top">
                            <p>{{ nota.ano ? nota.ano : '-' }}</p>
                        </th>
                        <th class="col-t-30 coluna-tabela center border-top">
                            <p>{{ nota.unidade_ensino ? nota.unidade_ensino : '-' }}</p>
                        </th>
                        <th class="col-t-20 coluna-tabela center border-top">
                            <p>{{ nota.cidade ? nota.cidade : '-' }}</p>
                        </th>
                        <th class="col-t-10 coluna-tabela center border-top ultima-coluna">
                            <p>{{ nota.UF ? nota.UF : '-' }}</p>
                        </th>
                    </tr>
                    
                </table>
            </div>

            <!-- equivalência -->
            <div class="borda mt-10">
                <table class="tabela-nota linha-tabela ultima-linha">
                    <tr>
                        <th colspan="2" class="col-t-30 coluna-tabela center ultima-coluna">
                            <p>EQUIVALÊNCIA COM O ENSINO FUNDAMENTAL REGULAR</p>
                        </th>
                    </tr>
                    <tr v-for="(equivalencia, idNota) in dados.grade.conteudo.equivalencia">
                        <th class="col-t-100 coluna-tabela border-top">
                            <p>{{ equivalencia }}</p>
                        </th>
                    </tr>
                    <template v-if="dados.grade.conteudo.equivalencia.length == 0">
                        <tr>
                            <th class="col-t-100 coluna-tabela border-top center ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela border-top center ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela border-top center ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela border-top center ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela border-top center ultima-coluna">-</th>
                        </tr>
                    </template>
                </table>
            </div>

            <!-- observações -->
            <div class="borda mt-10">
                <table class="tabela-nota linha-tabela ultima-linha">
                    <tr>
                        <th @click="showDialogObservacoes()" colspan="" class="col-t-30 coluna-tabela center ultima-coluna u-pointer">
                            <p>OBSERVAÇÕES <i class="fas fa-edit" style="color: #838383"></i></p>                            
                        </th>
                    </tr>
                    <tr v-if="dados.grade.conteudo.observacoes">
                        <th class="col-t-100 coluna-tabela border-top ultima-coluna">
                            <p>{{ dados.grade.conteudo.observacoes }}</p>
                        </th>
                    </tr>
                    <template v-if="!dados.grade.conteudo.observacoes">
                        <tr>
                            <th class="col-t-100 coluna-tabela center border-top ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela center border-top ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela center border-top ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela center border-top ultima-coluna">-</th>
                        </tr>
                    </template>
                </table>
            </div>

            <el-row :gutter="10" class="u-mt-10">
                <el-col :xs="24" :sm="24" :md="24">
                    <div class="u-text-right">
                        <el-button @click="onSubmitHistoricoEscolar()">IMPRIMIR</el-button>
                    </div>
                </el-col>
            </el-row>

            <el-dialog :close-on-click-modal="false" title="IMPRESSÃO HISTÓRICO ESCOLAR" width="50%" :visible.sync="dialogEditNota" v-on:close="closeDialogEditNota" append-to-body>
                <div v-if="dialogEditNota" style="margin-top: 20px;">
                    <template v-if="dados.grade.conteudo.notas[idNotaSelected].origem == 'interna'">
                        <div class="borda mt-10" style="border-top: none;">
                            <table class="tabela-nota linha-tabela ultima-linha">
                                
                                <tr v-for="(nota, disciplina) in dados.grade.conteudo.notas[idNotaSelected].disciplinas">
                                    <th class="col-t-50 coluna-tabela border-top">
                                        <p>{{ dados.disciplinas[disciplina] }}</p>
                                    </th>
                                    <th class="col-t-50 coluna-tabela border-top ultima-coluna">
                                        <p>
                                            <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].disciplinas[disciplina]" maxlength="191"></el-input>
                                        </p>
                                    </th>                  
                                </tr>      

                            </table>
                        </div>
                    </template>
                    <template v-else>
                        <el-form label-position="top">
                            <el-row :gutter="10" v-for="(item, i) in formNotaExterna" class="u-mt-5">
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Disciplina" prop="disciplina" key="disciplina">
                                        <el-input v-model="formNotaExterna[i].disciplina" maxlength="191" v-on:blur="formatData(i, 'disciplina')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="11" :md="11">
                                    <el-form-item label="Nota" prop="nota" key="nota">
                                        <el-input v-model="formNotaExterna[i].nota" maxlength="191"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="1" :md="1" class="u-text-right" v-if="formNotaExterna.length > 1">
                                    <el-button @click="removeDisciplina(i)" type="danger" plain style="margin-top: 21px;">
                                        <i class="fas fa-trash-alt"></i>
                                    </el-button>
                                </el-col>
                            </el-row>                            
                        </el-form>
                    </template>
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-button @click="addDisciplina()" type="primary" plain>
                                <i class="fas fa-plus"></i> ADICIONAR DISCIPLINA
                            </el-button>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <div class="u-text-right">
                                <el-button @click="onSubmitFormEditNota" native-type="submit">SALVAR</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" title="GERENCIAR ESTUDOS REALIZADOS" width="70%" :visible.sync="dialogEstudosRealizados" v-on:close="closeDialogEstudosRealizados" append-to-body>
                <div v-if="dialogEstudosRealizados" style="margin-top: 20px;">
                    
                    <el-form label-position="top">
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Ano" prop="ano" key="ano">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].ano" maxlength="191"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>    
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Unidade de Ensino" prop="unidade_ensino" key="unidade_ensino">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].unidade_ensino" maxlength="191" v-on:blur="formatDataUnidade('unidade_ensino')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>  
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Cidade" prop="cidade" key="cidade">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].cidade" maxlength="191" v-on:blur="formatDataUnidade('cidade')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Estado" prop="UF" key="UF">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].UF" maxlength="191" v-on:blur="formatDataUnidade('UF')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row> 
                    </el-form>
                        
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <div class="u-text-right">
                                <el-button @click="onSubmitEstudosRealizados()" native-type="submit">SALVAR</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" title="GERENCIAR OBSERVAÇÕES" width="70%" :visible.sync="dialogObservacoes" v-on:close="closeDialogObservacoes" append-to-body>
                <div v-if="dialogObservacoes" style="margin-top: 20px;">
                    
                    <el-form label-position="top">
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Observações" prop="observacoes" key="observacoes">
                                    <el-input type="textarea" autosize v-model="dados.grade.conteudo.observacoes"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>  
                    </el-form>                        
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <div class="u-text-right">
                                <el-button @click="onSubmitObservacoes()" native-type="submit">SALVAR</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>
            
        </div>
</template>
<script>
import Vue from 'vue'

export default {
    props: ['aluno'],
    data: () => ({
        idNotaSelected: '',
        dialogEditNota: false,
        dialogEstudosRealizados: false,
        dialogObservacoes: false,
        loading: true,
        dados:{ },
        formNotaExterna: [{
            disciplina: '',
            nota: ''
        }]
    }),
    mounted () {

        this.getDados()
    },
    methods:{
        getDados(){

            this.loading = true;

            let i = this.$store.state.config.instituicao.id;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/get-dados-historico-escolar/${i}/${this.aluno.id}`, this.$store.getters.getHeaderAuth).then(response => {

                if(typeof response.data.erro !== 'undefined'){

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                    this.$emit('closeModal');

                }else{

                    this.dados = response.data;
                    this.loading = false;
                }
                
            }).catch((error) => { this.$store.commit('throwException', error); });
            
        },
        showDialogEditNotas(idNota) {
            this.dialogEditNota = true;
            this.idNotaSelected = idNota;
        },
        closeDialogEditNota() {
            this.dialogEditNota = false;
            this.idNotaSelected = {};
            this.formNotaExterna = [{
                disciplina: '',
                nota: ''
            }]
        },
        onSubmitFormEditNota() {

            if(this.dados.grade.conteudo.notas[this.idNotaSelected].origem == 'interna') {

                this.dialogEditNota = false;

            } else {

                Vue.set(this.dados.grade.conteudo.notas[this.idNotaSelected], 'disciplinas_traducao', {});

                for(let i in this.formNotaExterna) {

                    let indice = this.idNotaSelected + i + this.idNotaSelected;

                    if (Array.isArray(this.dados.grade.conteudo.notas[this.idNotaSelected].disciplinas)) {
                        this.dados.grade.conteudo.notas[this.idNotaSelected].disciplinas = {};
                    }
                    
                    Vue.set(this.dados.disciplinas, indice, this.formNotaExterna[i].disciplina);
                    Vue.set(this.dados.grade.conteudo.notas[this.idNotaSelected].disciplinas, indice, this.formNotaExterna[i].nota);
                    Vue.set(this.dados.grade.conteudo.notas[this.idNotaSelected].disciplinas_traducao, indice, this.formNotaExterna[i].disciplina);
                }
                this.dialogEditNota = false;
            }
            
        },
        addDisciplina() {
            this.formNotaExterna.push({
                disciplina: '',
                nota: ''
            });
        },
        removeDisciplina(i) {
            this.formNotaExterna.splice(i, 1);
        },        
        showDialogEstudosRealizados(idNota) {
            this.dialogEstudosRealizados = true;
            this.idNotaSelected = idNota;
        },
        closeDialogEstudosRealizados() {
            this.dialogEstudosRealizados = false;
            this.idNotaSelected = {};
        },
        onSubmitEstudosRealizados(){

            this.dialogEstudosRealizados = false;
        },   
        showDialogObservacoes() {
            this.dialogObservacoes = true;
        },
        closeDialogObservacoes() {
            this.dialogObservacoes = false;
        },
        onSubmitObservacoes(){

            this.dialogObservacoes = false;
        },
        formatData(i, field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.formNotaExterna[i][field])
                return false;

            if(size && this.formNotaExterna[i][field].length < size)
                this.formNotaExterna[i][field] = '';            

            this.formNotaExterna[i][field] = this.formNotaExterna[i][field].toUpperCase();

            this.formNotaExterna[i][field] = this.$removerAcentos(this.formNotaExterna[i][field]);
        },
        formatDataUnidade(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.dados.grade.conteudo.notas[this.idNotaSelected][field])
                return false;

            if(size && this.dados.grade.conteudo.notas[this.idNotaSelected][field].length < size)
                this.dados.grade.conteudo.notas[this.idNotaSelected][field] = '';            

            this.dados.grade.conteudo.notas[this.idNotaSelected][field] = this.dados.grade.conteudo.notas[this.idNotaSelected][field].toUpperCase();

            this.dados.grade.conteudo.notas[this.idNotaSelected][field] = this.$removerAcentos(this.dados.grade.conteudo.notas[this.idNotaSelected][field]);
        },
        onSubmitHistoricoEscolar() {

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeHistoricoEscolar/${this.aluno.id}`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
            
                if(typeof response.data.erro !== 'undefined'){

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

                }else{

                    let i = this.$store.state.config.instituicao.id;

                    window.eventBus.$emit('print', {url: '/api/diario/printHistoricoEscolar', param: {aluno_id: this.aluno.id, instituicao_id: i }});

                    this.$emit('closeModal');
                }

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        }, 
    },
    components:{ }
}
</script>
<style scoped>

    p {
        font-size: 11px;
        font-weight: normal;
    }

    b {
        font-weight: bold;
    }

    h3 {
        font-size: 13px;
        font-weight: bold;
    }

    h4 {
        font-size: 13px;
        font-weight: normal;
    }

    table, td, th {
        table-layout: auto;
        width: 100%;
    }

    .linha {
        padding-left: 10px;
        padding-right: 10px;
    }

    .primeira-linha {
        padding-top: 5px;
    }

    .linha-tabela {
        border-collapse: collapse;
        border-bottom: 1px solid black;
    }

    .ultima-linha {
        border-bottom: none;
    }

    .coluna-tabela {
        table-layout: auto;
        border-right: 1px solid black;
        text-align: left;
    }

    .ultima-coluna {
        border-right: none;
    }

    .quadro-interno {
        height: 115px;
    }

    .quadro-lateral {
        margin-left: 8px;
        margin-right: 8px;
        height: 115px;
    }

    .col-t-5 {
        width: 5%;
    }

    .col-t-10 {
        width: 10%;
    }

    .col-t-15 {
        width: 15%;
    }

    .col-t-20 {
        width: 20%;
    }

    .col-t-25 {
        width: 25%;
    }

    .col-t-30 {
        width: 30%;
    }

    .col-t-33 {
        width: 33%;
    }

    .col-t-35 {
        width: 35%;
    }

    .col-t-40 {
        width: 40%;
    }

    .col-t-42 {
        width: 42%;
    }

    .col-t-45 {
        width: 42%;
    }

    .col-t-50 {
        width: 50%;
    }

    .col-t-55 {
        width: 50%;
    }

    .col-t-60 {
        width: 60%;
    }

    .col-t-65 {
        width: 60%;
    }

    .col-t-70 {
        width: 70%;
    }

    .col-t-75 {
        width: 70%;
    }

    .col-t-80 {
        width: 80%;
    }

    .col-t-85 {
        width: 80%;
    }

    .col-t-90 {
        width: 90%;
    }

    .col-t-95 {
        width: 90%;
    }

    .col-t-100 {
        width: 100%;
    }

    .borda {
        overflow-x: hidden;
        border: 1px solid #000000;
        border-radius: 8px;
        /* margin-bottom: 3px; */
        font-weight: 700;
    }

    .center {
        text-align: center;
    }

    .top {
        padding-top: 20px;
    }

    .right {
        text-align: right;
    }

    .justify {
        text-align: justify;
    }

    h2 {
        font-size: 16px;
    }

    h1 {
        font-size: 18px;
        font-weight: normal;
    }

    html{
        /* margin:20px 50px; */
        margin: 25px 25px 25px 25px; /* top right bottom left */
    }

    h1,h2,h3,h4,th,td,p,div,b {
        margin: 0;
        padding: 0;
    }

    .linha-tabela p {
        margin: 2px 2px 3px 4px;
    }

    .borda {
        margin-bottom: 5px;
    }

    .margin-bottom-5 {
        margin-bottom: 8px;
    }

    .margin-bottom-10 {
        margin-bottom: 10px;
    }

    .small-font {
        font-size: 10px;
    }

    .tiny-font {
        font-size: 5px;
    }

    .linha-tracejada {
        border: none;
        border-top: 1px dotted black;
        color: #fff;
        background-color: #fff;
        height: 1px;
    }

    .mt-40{
        margin-top: 40px !important;
    }

    .mt-30{
        margin-top: 30px !important;
    }

    .mt-20{
        margin-top: 20px !important;
    }

    .mt-10{
        margin-top: 5px;
    }

    .mt-5{
        margin-top: 5px;
    }

    .pl-10{
        padding-left: 10px;
    }

    .border05{
        border-bottom: 0.5px solid #000;
    }

    .my-5{
        margin: 5px 0px;
    }

    .text-left{
        text-align: left !important;
    }

    .requerimento {
        font-family: "Arial", "Helvetica", "sans-serif";
        page-break-inside: avoid;
    }

    .page-break {
        page-break-after: always;
    }

    .page-break:last-child {
        page-break-after: auto;
    }

    .border-top {
        border-top: 1px solid #000;
    }

    .vertical{
        writing-mode: vertical-rl;
        transform: rotate(180deg);
    }
</style>